import React, { useEffect, useMemo, useRef, useState } from "react";
import { connect } from "react-redux";
import find from "lodash/find";
import {
  faPeopleArrows,
  faNotesMedical,
  faGripLinesVertical,
  faUsers,
  faCalendarAlt,
  faGenderless,
  faGlobe,
  faUserFriends,
} from "@fortawesome/free-solid-svg-icons";
import isEmpty from "lodash/isEmpty";
import {
  ETHINICITES_ABBREVIATIONS_TO_ETHNICITIES,
  SEX_ABBREVIATIONS_TO_SEX,
} from "../../../../../common/helpers/Constant";
import helpers from "../../../../../common/utils/utils";
import store from "../../../../../state/store";
import { extractGenes } from "../../../../../state/helpers/extractGenes";
import { getResultUrl } from "../../../../../state/actions/getResultUrl";
import { checkMultipleTranscripts } from "../../../../../state/helpers/checkMultipleTranscripts";
import { getFirstCanonicalTranscript } from "../../../../../state/helpers/getFirstCanonicalTranscript";
import { sortTranscripts } from "../../../../../state/helpers/sortTranscripts";
import { setMainTranscript } from "../../../../../state/helpers/setMainTranscript";
import { checkForThrottlingError } from "../../../../../state/actions/checkForThrottlingError";
import { varsomePremiumUrl } from "../../../../../common/helpers/Urls";
import ComponentPanel from "../../../../../components/atoms/ComponentPanel/ComponentPanel";
import {
  Loading,
  SampleFindingsTable,
  ToggleButton,
} from "../../../../../components/atoms";
import SearchModal from "../../../../../components/atoms/SearchModal/SearchModal";
import {
  getAcmgGene,
  getVariantId,
  getClassifications,
  getRulesThatMetCriteria,
  getActiveRulesList,
  getAcmgCancerExplain,
  getAcmgVerdict,
  getPillsToggleState,
  getActiveOverrideStrengths,
  getAllRulesToggleState,
  getAcmgSampleFindings,
  getAcmgDefaultVerdictRules,
  isThaliaVersionSmallerThanElevenPointFour,
  getACMGThrottlingStatus,
  getACMGVersionName,
  getAcmgTranscriptName,
  getAcmgTranscriptReason,
} from "../../../../../state/selectors/ACMGComponent.selectors";
import { getIfSomatic } from "../../../../../state/selectors/GermlineSomatic.selectors";
import withErrorGuard from "../../../../../HOC/withErrorGuard";
import { getVarsoUrl } from "../../../../../common/helpers/helpers";
// import withPubmedModal from "../../../../../HOC/withPubmedModal";
import ls from "../../../../../common/helpers/localStorageActions";
import Modal from "../../../../../components/atoms/Modal";
import HelperText from "../../../../../components/atoms/HelperText";
import {
  setAcmgToggleStateAction,
  setAcmgActiveOverridesStrengthAction,
  setAcmgToggleToDefaultAction,
  setAcmgActiveOverridesToDefaultAction,
} from "../../../../../state/actions/AcmgActions";
import ClinvarButton from "../../../../clinvar-submissions/ClinvarButton";
import AnnotationThrottled from "../annotation-throttled";
import TermsOfUseACMG from "../terms-of-use";
import {
  getEnsemblTranscripts,
  getRefSeqTranscripts,
} from "../../transcripts/selectors/transcriptsSelectors.selectors";
import { getManeTranscriptForACMG } from "../../transcripts/helpers";
import ACMGScores from "../acmg-scores";
import { httpRequest } from "../../../../../services/http";

import { checkResetedRules, createRuleParams } from "../helpers";
import {
  FAMILY_MEMBERS_AFFECTED_MAP,
  INFORMATIVE_ACMG_MESSAGE,
} from "../static";
import AcmgPanelRight from "./panel-buttons-right/AcmgPanelRight";
import TranscriptUsedInPortal from "./transcript-used-portal";
import AcmgPremiumMessage from "./acmg-premium-message";
import FailedWarning from "./failed-warning";
import TranscriptsDropdown from "./transcripts-dropdown";
import ReAnnotationButton from "./re-annotation-button";
import VerdictRenderer from "./verdict-renderer";
import AutomatedCriteriaTable from "./automated-criteria-table";
import ManualComponentOverride from "./manual-component-override";
import {
  AcmgAnnotationDefaultProps,
  AcmgAnnotationPropTypes,
} from "./AcmgAnnotation.props";
import ErrorWarningText from "./error-warning-text/ErrorWarningText";
import TranscriptOptionLabel from "./transcript-option-label/TranscriptOptionLabel";

const ACMGAnnotation = ({
  schema,
  acmgRules,
  variantResult,
  varsomeHost,
  acmgGene,
  classifications,
  rulesThatMetCriteria,
  activeRulesList,
  isSomatic,
  query,
  queryType,
  variantClassesList,
  cancerExplain,
  pillsToggleState,
  activeOverrideStrengths,
  allRulesToggleState,
  setAcmgToggleToDefault,
  setAcmgActiveOverridesToDefault,
  setAcmgToggleState,
  setAcmgActiveOverridesStrength,
  acmgSampleFindings,
  variantQueryMode,
  componentTitle,
  defaultVerdictRules,
  refseqTranscriptsOptions,
  ensemblTranscriptsOptions,
  variantId,
  shouldShowACMGPoints,
  acmgVersionName,
  isACMGThrottled,
  apiUrl,
  transcriptName,
  transcriptReason,
  userEmail,
  refGenome,
}) => {
  const [isTermsModalOpen, setTermsModalOpen] = useState(false);
  const [getAcmgSelectedTranscript, setAcmgSelectedTranscript] = useState(true);
  const [acmgSelected, setAcmgSelected] = useState(undefined);
  const [isSearchModalOpen, setSearchModalOpen] = useState(false);
  const [showFailedCriteria, setFailedCriteria] = useState(
    ls.getAcmgFailedCriteria() || false
  );
  const [showSummaryView, setSummaryView] = useState(
    ls.getAcmgSummaryView() || false
  );
  const [showClinicalEvidence, setClinicalEvidence] = useState(true);
  let pendingRequestController = null;
  const [loading, setLoadingState] = useState(false);
  const [reannotateWarning, setReannotateWarning] = useState("");
  const [localStateVerdict, setLocalStateVerdict] =
    useState(defaultVerdictRules);

  const resetFlag = useRef(false);

  const url = useMemo(
    () => getVarsoUrl("https://www.ncbi.nlm.nih.gov/pmc/articles/PMC4544753/"),
    []
  );

  const version = useMemo(() => acmgVersionName, [acmgVersionName]);

  const {
    phenotypes,
    diseases,
    zygosity,
    inheritance,
    age,
    ethnicity,
    sex,
    familyMembersAffected,
    annotation_mode: annotationMode,
    familySegregation,
  } = variantQueryMode;

  const clinicalEvidenceRules = useMemo(() => ["PP5", "BP6", "PS3", "BS3"], []);

  const ethnicityFromAbbreviation = useMemo(
    () => ethnicity && ETHINICITES_ABBREVIATIONS_TO_ETHNICITIES[ethnicity],
    [ethnicity]
  );

  const sexFromAbbreviation = useMemo(
    () => sex && SEX_ABBREVIATIONS_TO_SEX[sex],
    [sex]
  );

  const phenotypesDiseases = useMemo(() => {
    if (Array.isArray(phenotypes) && phenotypes.length > 0) {
      if (Array.isArray(diseases) && diseases.length > 0) {
        return [...phenotypes, ...diseases];
      }
      return [...phenotypes];
    }

    if (Array.isArray(diseases) && diseases.length > 0) {
      return [...diseases];
    }

    return "";
  }, [diseases, phenotypes]);

  const setStateToDefault = () => {
    setAcmgToggleToDefault();
    setAcmgActiveOverridesToDefault();
  };

  useEffect(() => {
    setLocalStateVerdict(defaultVerdictRules);
  }, [variantId, variantResult]);

  const getNewAnnotationRequest = () => {
    const ruleParams = createRuleParams(
      acmgRules,
      rulesThatMetCriteria,
      activeOverrideStrengths,
      pillsToggleState
    );

    const getNewAnnotationUrl = ruleParams
      ? `${apiUrl}/acmg_verdict?${ruleParams}`
      : `${apiUrl}/acmg_verdict`;
    setLoadingState(true);

    httpRequest
      .get(getNewAnnotationUrl)
      .then((response) => {
        resetFlag.current = true;
        if (variantResult?.acmg_annotation?.verdict?.ACMG_rules) {
          setLocalStateVerdict(response.data.ACMG_rules);
        }
      })
      .catch((error) => {
        resetFlag.current = true;
        const { status } = error.response;
        console.error("While getting acmg verdict:", error);
        if (status >= 500) {
          setReannotateWarning(
            error.message
              ? error.message
              : "Something went wrong, please try again!"
          );
        }
      })
      .finally(() => {
        setLoadingState(false);
      });
  };

  useEffect(() => {
    if (
      (!isEmpty(pillsToggleState) || !isEmpty(activeOverrideStrengths)) &&
      resetFlag.current
    ) {
      getNewAnnotationRequest();
    }
  }, [pillsToggleState, activeOverrideStrengths, resetFlag]);

  useEffect(() => {
    /*
    * If we set some rules and then reset them there is a chance that the verdict will
    * be the one from the latest thalia version. Eg
    ? Initial state -> Uncertain significance/Benign
    ? Random pills toggle state -> Likely Benign
    ? Reseted pills state -> Benign (this is not wrong according to the thalia logic latest version)
    ? Real state that is in redux and corresponds to the row -> Uncertain significance/Benign
    ! This case only occurs in varsome clinical, since varsome always uses the latest thalia version
    */
    const rulesAreReseted = checkResetedRules(
      pillsToggleState,
      activeRulesList,
      rulesThatMetCriteria,
      activeOverrideStrengths
    );

    if (
      __IS_COMPONENTS_PORTAL__ &&
      pillsToggleState &&
      !isEmpty(pillsToggleState) &&
      rulesAreReseted
    ) {
      setLocalStateVerdict(defaultVerdictRules);
    }

    return () => {};
  }, [pillsToggleState, defaultVerdictRules, localStateVerdict]);

  useEffect(() => {
    setStateToDefault();
    setClinicalEvidence(true);
    resetFlag.current = true;
  }, [variantId]);

  // used for Clinical because ACMG component wont re-render when the variant changes
  // used also in varsome when the variant changes

  const getNewTranscriptAnnotation = (e) => {
    const selectedVariant = variantResult && variantResult.variant_id;
    let m;

    if (acmgSelected) {
      m = acmgSelected.name;
    }

    setReannotateWarning("");
    setLoadingState(true);

    setStateToDefault();
    setClinicalEvidence(true);

    // eslint-disable-next-line no-shadow
    const url =
      e.value === m ? getResultUrl(false) : getResultUrl(false, e.value);

    if (pendingRequestController) {
      pendingRequestController.abort();
    }

    pendingRequestController = new AbortController();
    httpRequest
      .get(url, { signal: pendingRequestController.signal })
      .then((response) => {
        let v;
        let multipleResults;
        const { data } = response;
        if (Array.isArray(data)) {
          /* Query type is c_notation or aminoacid. */
          if (queryType === "c_notation" || queryType === "aminoacid") {
            /* If query starts from NM and ENST
                there are multiple results but we won't show
                an intermediate screen.
                e.g. NM_001126113.2(TP53):G187S
            */
            if (
              query.toUpperCase().indexOf("NM") === 0 ||
              query.toUpperCase().indexOf("ENST") === 0
            ) {
              let name = query.toUpperCase().split("(");
              if (name.length === 1) {
                [name] = name[0].split(":");
              } else {
                [name] = name;
              }
              for (let i = 0; i < data.length; i++) {
                const q = data[i];
                if (Array.isArray(v)) {
                  q.forEach((subv) => {
                    sortTranscripts(subv, "ensembl_transcripts", "name", name);
                    sortTranscripts(subv, "refseq_transcripts", "name", name);
                  });
                } else {
                  sortTranscripts(v, "ensembl_transcripts", "name", name);
                  sortTranscripts(v, "refseq_transcripts", "name", name);
                }
              }
            } else if (queryType === "c_notation") {
              /* If query doesn't start from NM and ENST and its type is
                  c_notation we will show the intermediate screen
                  if there are multiple transcripts.
                  e.g. BAIAP2L2:c.395_436del
              */
              let idx;
              const cPart = query.split(":")[1].toUpperCase();
              data.forEach((c, i) => {
                if (Array.isArray(c.ensembl_transcripts)) {
                  for (
                    let j = 0;
                    j < c.ensembl_transcripts[0].items.length;
                    j++
                  ) {
                    const transcript = c.ensembl_transcripts[0].items[j];
                    const hgvs =
                      transcript.hgvs && transcript.hgvs.toUpperCase();
                    if (cPart === hgvs && transcript.canonical) {
                      /* This is the main variantResult,
                          keeping the index to move it to
                          start of multipleResults.
                      */
                      idx = i;
                      break;
                    }
                  }
                }
                if (Array.isArray(c.refseq_transcripts)) {
                  for (
                    let j = 0;
                    j < c.refseq_transcripts[0].items.length;
                    j++
                  ) {
                    const transcript = c.refseq_transcripts[0].items[j];
                    const hgvs =
                      transcript.hgvs && transcript.hgvs.toUpperCase();
                    if (cPart === hgvs && transcript.canonical) {
                      /* This is the main variantResult,
                          keeping the index to move it to
                          start of multipleResults.
                      */
                      idx = i;
                      break;
                    }
                  }
                }
                sortTranscripts(c, "ensembl_transcripts", "hgvs", cPart);
                sortTranscripts(c, "refseq_transcripts", "hgvs", cPart);
              });
              /* Moving the variantResult that corresponds to the
                  canonical transcript to start of multipleResults.
              */
              if (idx) data.splice(0, 0, data.splice(idx, 1)[0]);

              const match = helpers.validators.is_c_notation(query);
              checkMultipleTranscripts(data, match, false);
            } else if (queryType === "aminoacid") {
              /* If query doesn't start from NM and ENST and its type
                is aminoacid we will show the intermediate screen
                if there are multiple transcripts.
                e.g. TP53:G187S
              */
              data.forEach((a) => {
                const isAminoacid = helpers.validators.is_aminoacid(query);
                const p = query.split(":")[1].toUpperCase();
                // if it's 3-letter aminoacid, add a capital P.
                const pPart = isAminoacid[4].length === 3 ? `P.${p}` : p;
                const pPartName =
                  isAminoacid[4].length === 3 ? "hgvs_p3" : "hgvs_p1";
                if (Array.isArray(v)) {
                  v.forEach((subv) => {
                    sortTranscripts(
                      subv,
                      "ensembl_transcripts",
                      pPartName,
                      pPart
                    );
                    sortTranscripts(
                      subv,
                      "refseq_transcripts",
                      pPartName,
                      pPart
                    );
                  });
                } else {
                  sortTranscripts(a, "ensembl_transcripts", pPartName, pPart);
                  sortTranscripts(a, "refseq_transcripts", pPartName, pPart);
                }
              });
              const match = helpers.validators.is_aminoacid(query);
              checkMultipleTranscripts(data, match, true);
            }
          } else {
            data.forEach((d) => {
              if (Array.isArray(d.ensembl_transcripts)) {
                const ensemblItems = d.ensembl_transcripts[0].items;
                /* Just scan for the first canonical
                  (or the first one if none canonical)
                  and set it as main.
                */
                const idx = getFirstCanonicalTranscript(ensemblItems);
                setMainTranscript(d, ensemblItems, idx);
                extractGenes(d, ensemblItems);
              }
              if (Array.isArray(m.refseq_transcripts)) {
                const refseqItems = d.refseq_transcripts[0].items;
                /* Just scan for the first canonical
                  (or the first one if none canonical)
                  and set it as main.
                */
                const idx = getFirstCanonicalTranscript(refseqItems);
                setMainTranscript(d, refseqItems, idx);
                extractGenes(d, refseqItems);
              }
            });
          }

          multipleResults = data;
          let a;
          let b;

          data.forEach((g, i) => {
            if (Array.isArray(g)) {
              v.forEach((p, j) => {
                if (p.variant_id === selectedVariant) {
                  a = i;
                  b = j;
                }
              });
            }
            if (g.variant_id === selectedVariant) {
              a = i;
            }
          });

          if (typeof b !== "undefined") {
            // eslint-disable-next-line no-param-reassign
            variantResult = data[a][b];
          } else {
            // eslint-disable-next-line no-param-reassign
            variantResult = data[a];
          }
        } else {
          v = data;
          /* If query type is
              aminoacid e.g. BRAF:V600E
              or
              c_notation e.g. NM_001178008.2:c.210-100_210-99delTT
          */
          if (queryType === "c_notation" || queryType === "aminoacid") {
            if (
              query.toUpperCase().indexOf("NM") === 0 ||
              query.toUpperCase().indexOf("ENST") === 0
            ) {
              let qName = query.toUpperCase().split("(");
              if (qName.length === 1) {
                [qName] = qName[0].split(":");
              } else {
                [qName] = qName;
              }
              sortTranscripts(v, "ensembl_transcripts", "name", qName);
              sortTranscripts(v, "refseq_transcripts", "name", qName);
            } else if (queryType === "c_notation") {
              const cPart = query.split(":")[1].toUpperCase();
              sortTranscripts(v, "ensembl_transcripts", "hgvs", cPart);
              sortTranscripts(v, "refseq_transcripts", "hgvs", cPart);
            } else if (queryType === "aminoacid") {
              const isAminoacid = helpers.validators.is_aminoacid(query);
              const p = query.split(":")[1].toUpperCase();
              /* If it's 3-letter aminoacid, add a capital P. */
              const pPart = isAminoacid[4].length === 3 ? `P.${p}` : p;
              const pPartName =
                isAminoacid[4].length === 3 ? "hgvs_p3" : "hgvs_p1";

              if (Array.isArray(v)) {
                v.forEach((subv) => {
                  sortTranscripts(
                    subv,
                    "ensembl_transcripts",
                    pPartName,
                    pPart
                  );
                  sortTranscripts(subv, "refseq_transcripts", pPartName, pPart);
                });
              } else {
                v = sortTranscripts(v, "ensembl_transcripts", pPartName, pPart);
                v = sortTranscripts(v, "refseq_transcripts", pPartName, pPart);
              }
            }
          } else {
            /* In any other case:
                chr e.g. chr17-7578371-C-T
                varid e.g. 10190071404531360004
                rsid e.g. rs145236923
                vdf e.g. chr21 44488823 rs529461463;rs749276808 GAA G
            */
            if (Array.isArray(v.ensembl_transcripts)) {
              const otherItems = v.ensembl_transcripts[0].items;
              const idx = getFirstCanonicalTranscript(otherItems);
              setMainTranscript(v, otherItems, idx);
              extractGenes(v, otherItems);
            }
            if (Array.isArray(v.refseq_transcripts)) {
              const otherItems = v.refseq_transcripts[0].items;
              const idx = getFirstCanonicalTranscript(otherItems);
              setMainTranscript(v, otherItems, idx);
              extractGenes(v, otherItems);
            }
          }

          // eslint-disable-next-line no-param-reassign
          variantResult = v;
        }

        store.dispatch({
          type: "SET_CURRENT_VARIANT",
          result: { variantResult },
        });
        store.dispatch({
          type: "SET_MULTIPLE_RESULTS",
          multipleResults,
        });
      })
      .catch((error) => {
        const { data } = error.response;
        if (!checkForThrottlingError(error)) {
          console.error("While getting new acmg re-annotate:", error);
          const errorMessage = data.detail ? data.detail : error.message;
          setReannotateWarning(
            errorMessage || "Something went wrong, please try again!"
          );
        }
      })
      .finally(() => {
        setLoadingState(false);
        pendingRequestController = null;
      });
  };

  const onToggleHandle = (classification, isChecked) => {
    const {
      name,
      strength,
      acmg_triggered_strength: acmgTriggeredStrength,
    } = classification;

    const defaultStrength = name === "BA1" ? "Stand Alone" : "Very Strong";
    setAcmgToggleState({ [name]: isChecked });
    setAcmgActiveOverridesStrength({
      [name]: acmgTriggeredStrength || strength || defaultStrength,
    });
  };

  const onAcmgSelectChange = (e, name) => {
    setAcmgActiveOverridesStrength({
      [name]: e.value,
    });
  };

  const onDisableClinicalEvidence = (isEnabled) => {
    const disabledRules = {};
    clinicalEvidenceRules.forEach((c) => {
      const r = find(activeRulesList, { name: c });
      if (r && r.isActive) {
        disabledRules[c] = isEnabled;
      }
    });
    setAcmgToggleState(disabledRules);
  };

  const res = variantResult?.acmg_annotation;

  const ensemblTranscripts = useMemo(() => {
    if (variantResult?.ensembl_transcripts)
      return variantResult.ensembl_transcripts[0].items;
    // Until now ensemblTranscripts was left to undefined but later a .filter is used
    return [];
  }, [variantResult]);

  const transcriptsOptions = useMemo(() => {
    if (res?.transcript_candidates) {
      return res.transcript_candidates.map((item) => {
        if (getAcmgSelectedTranscript && item.name === res.transcript) {
          setAcmgSelected({
            name: res.transcript,
            reason: res.transcript_reason,
            canonical: item.canonical,
            plength: item.total_coding_length,
            gene: item.gene_symbol,
            impact: item.coding_impact,
          });
          setAcmgSelectedTranscript(false);
        }

        return {
          value: item.name,
          label: (
            <TranscriptOptionLabel
              varsomeHost={varsomeHost}
              refGenome={refGenome}
              item={item}
              refseqTranscriptsOptions={refseqTranscriptsOptions}
              ensemblTranscriptsOptions={ensemblTranscriptsOptions}
            />
          ),
        };
      });
    }

    return undefined;
  }, [
    refseqTranscriptsOptions,
    ensemblTranscriptsOptions,
    varsomeHost,
    res,
    getAcmgSelectedTranscript,
    setAcmgSelectedTranscript,
    setAcmgSelected,
    getManeTranscriptForACMG,
  ]);

  const missingAcmgTranscriptMessage = useMemo(() => {
    if (res && !res.transcript && res.transcript_reason) {
      return res.transcript_reason;
    }
    return undefined;
  }, [res]);

  const errorWarning = useMemo(() => {
    if (res && res.errors && res.errors.length > 0) {
      return true;
    }
    return false;
  }, [res]);

  const errors = useMemo(() => {
    if (res && res.errors && res.errors.length > 0) {
      return res.errors;
    }
    return [];
  }, [res]);

  const failedWarning = useMemo(() => res && res.user_explain_failed, [res]);

  // clean up old rules keys
  for (let i = 0; i < acmgRules?.length; i++) {
    const rule = acmgRules[i];
    delete rule.evidence;
    delete rule.met_criteria;
    delete rule.user_explain_failed;
    delete rule.acmg_triggered_strength;
  }

  /** Adding fields, evidence, met_criteria, user_explain_failed
    and acmg_triggered_strength to ACMG rule definitions. */
  for (let i = 0; i < res?.classifications?.length; i++) {
    const cl = res.classifications[i];
    for (let j = 0; j < acmgRules.length; j++) {
      const rule = acmgRules[j];
      if (rule.name === cl.name) {
        rule.evidence = cl.evidence;
        rule.met_criteria = cl.met_criteria;
        rule.user_explain_failed = cl.user_explain_failed;
        if (cl.met_criteria) {
          rule.acmg_triggered_strength = cl.strength;
        }
        break;
      }
    }
  }

  const finalPhenotypes = __IS_COMPONENTS_PORTAL__
    ? phenotypes
    : phenotypesDiseases;

  const finalDiseases = __IS_COMPONENTS_PORTAL__ ? diseases : "";

  const spotted = useMemo(
    () =>
      rulesThatMetCriteria
        ?.map((rule) => rule.name)
        .find(
          (el) => el === "PP5" || el === "BP6" || el === "PS3" || el === "BS3"
        ),
    [rulesThatMetCriteria]
  );

  if (!res) return null;

  if (!variantResult) return null;

  if (isACMGThrottled) {
    return (
      <AnnotationThrottled
        informativeMessage={INFORMATIVE_ACMG_MESSAGE}
        version={version}
        varsomeHost={varsomeHost}
        componentTitle={componentTitle}
        isACMG={true}
        url={url}
      />
    );
  }

  if (!defaultVerdictRules)
    return <div data-testid="no-default-verdict-rules" />;

  return schema && variantResult && variantResult.acmg_annotation ? (
    <div className="varsome-result-fixed cmpt_acmg">
      <div className="varsome-container varsome-container__basic">
        <ComponentPanel
          url={url}
          title="Germline Variant Classification"
          remount={true}
          version={version}
          informativeMessage={INFORMATIVE_ACMG_MESSAGE}
          titleDetailsRight={
            <AcmgPanelRight
              varsomeHost={varsomeHost}
              setTermsModalOpen={setTermsModalOpen}
            />
          }
          content={
            <div className="varsome-inner-container tw-relative">
              <div className="tw-absolute tw-right-0 tw-mr-12 tw-mb-3">
                <ClinvarButton type="primary" location="ACMG component" />
              </div>
              {errorWarning && (
                <ErrorWarningText
                  userEmail={userEmail}
                  errors={errors}
                  annotationTranscript={res.transcript}
                  ensemblTranscripts={ensemblTranscripts}
                  loading={loading}
                  transcriptsOptions={transcriptsOptions}
                  getNewTranscriptAnnotation={getNewTranscriptAnnotation}
                />
              )}
              {failedWarning && <FailedWarning failReason={failedWarning} />}
              {reannotateWarning && (
                <div
                  className="varsome-text-center tw-mt-8"
                  style={{ color: "red" }}
                >
                  {reannotateWarning}
                </div>
              )}
              {!errorWarning && (
                <div>
                  {!failedWarning && !reannotateWarning && (
                    <div className="tw-text-center">
                      <div
                        className={`tw-flex tw-align-center tw-items-center tw-justify-center ${
                          !__IS_COMPONENTS_PORTAL__ ? "tw-mb-4" : ""
                        }`}
                      >
                        {loading ? (
                          <Loading />
                        ) : (
                          <span>
                            <div className="tw-flex tw-justify-center tw-items-center">
                              <VerdictRenderer
                                localStateVerdict={localStateVerdict}
                                activeOverrideStrengths={
                                  activeOverrideStrengths
                                }
                                allRulesToggleState={allRulesToggleState}
                                acmgRules={acmgRules}
                                variantClassesList={variantClassesList}
                                rulesThatMetCriteria={rulesThatMetCriteria}
                              />
                              {shouldShowACMGPoints && (
                                <span className="tw-ml-4">
                                  <ACMGScores
                                    verdictRules={localStateVerdict}
                                  />
                                </span>
                              )}
                            </div>

                            <span>
                              {cancerExplain &&
                                !isSomatic &&
                                !__IS_COMPONENTS_PORTAL__ && (
                                  <React.Fragment>
                                    <span className="tw-text-xs tw-font-medium">
                                      {`Gene ${acmgGene} is associated with cancer`}
                                    </span>
                                    <ReAnnotationButton
                                      isSomatic={isSomatic}
                                      onClick={() => setSearchModalOpen(true)}
                                    />
                                  </React.Fragment>
                                )}
                            </span>
                          </span>
                        )}
                      </div>
                    </div>
                  )}
                  {!__IS_COMPONENTS_PORTAL__ &&
                    !failedWarning &&
                    !reannotateWarning && (
                      <div className="tw-text-center">
                        {missingAcmgTranscriptMessage}
                        <TranscriptsDropdown
                          transcriptsOptions={transcriptsOptions}
                          acmgSelected={acmgSelected}
                          transcript={res.transcript}
                          refGenome={refGenome}
                          onChange={getNewTranscriptAnnotation}
                          varsomeHost={varsomeHost}
                        />
                      </div>
                    )}
                  {__IS_COMPONENTS_PORTAL__ && !failedWarning && (
                    <div className="tw-text-center">
                      <TranscriptUsedInPortal
                        refGenome={refGenome}
                        reason={transcriptReason}
                        transcript={transcriptName}
                        varsomeHost={varsomeHost}
                      />
                    </div>
                  )}
                  {!failedWarning && !reannotateWarning && (
                    <div>
                      <AcmgPremiumMessage
                        premiumSources={variantResult?.not_subscribed_sources}
                        varsomePremiumUrl={varsomePremiumUrl}
                      />
                      <SampleFindingsTable
                        onEditClick={() => setSearchModalOpen(true)}
                        sampleFindings={acmgSampleFindings}
                        rows={[
                          {
                            icon: faPeopleArrows,
                            label: "Phenotypes",
                            content: "phenotypes",
                            submittedData: finalPhenotypes,
                            shouldShowOnAnnotationType: "germline",
                          },
                          {
                            icon: faUsers,
                            label: "Inheritance",
                            content: "inheritance",
                            submittedData: inheritance,
                            shouldShowOnAnnotationType: "germline",
                          },
                          {
                            icon: faUserFriends,
                            label: "Family members affected?",
                            content: "Family members affected?",
                            shouldShowOnAnnotationType: "germline",
                            submittedData:
                              FAMILY_MEMBERS_AFFECTED_MAP[
                                familyMembersAffected
                              ],
                          },
                          {
                            icon: faUserFriends,
                            shouldShowOnAnnotationType: "germline",
                            label: "Family Segregation",
                            content: "Family Segregation",
                            submittedData:
                              FAMILY_MEMBERS_AFFECTED_MAP[familySegregation],
                          },
                          {
                            icon: faGripLinesVertical,
                            shouldShowOnAnnotationType: "germline",
                            label: "Zygosity",
                            content: "zygosity",
                            submittedData: zygosity,
                          },
                          {
                            icon: faGenderless,
                            shouldShowOnAnnotationType: "germline",
                            label: "Sex",
                            content: "sex",
                            submittedData: sexFromAbbreviation,
                          },
                          {
                            icon: faCalendarAlt,
                            shouldShowOnAnnotationType: "germline",
                            label: "Age at onset",
                            content: "age",
                            submittedData: age,
                          },
                          {
                            icon: faGlobe,
                            shouldShowOnAnnotationType: "germline",
                            label: "Ethnicity",
                            content: "ethnicity",
                            submittedData: ethnicityFromAbbreviation,
                          },
                          {
                            icon: faNotesMedical,
                            shouldShowOnAnnotationType: "germline",
                            label: "Diseases",
                            content: "disease",
                            submittedData: finalDiseases,
                          },
                          {
                            icon: faNotesMedical,
                            shouldShowOnAnnotationType: "both",
                            label: "Mode of Inheritance",
                            content: "mode_of_inheritance",
                            // submittedData refers to the user's input.
                            // In case of mode_of_inheritance we don't have a user input but we do have sample findings.
                            submittedData: [],
                          },
                        ].filter((row) => {
                          if (annotationMode !== "germline") {
                            return row.shouldShowOnAnnotationType === "both";
                          }
                          return row;
                        })}
                      />
                      <div className="tw-flex tw-pt-6">
                        <h5>
                          Automated criteria{" "}
                          <HelperText fieldDescriptionKey="Identified criteria" />
                        </h5>
                        <div className="tw-flex">
                          <ToggleButton
                            label="Show summary view"
                            onToggleClick={(e) => {
                              setSummaryView(e.target.checked);
                              ls.setAcmgSummaryView(e.target.checked);
                            }}
                            isChecked={showSummaryView}
                          />
                        </div>
                        {spotted ? (
                          <div className="tw-flex">
                            <ToggleButton
                              label={
                                <React.Fragment>
                                  Enable clinical evidence
                                  <HelperText
                                    RenderContent={() =>
                                      "Re-evaluates the Germline Variant Classification verdict with the clinical evidence rules PP5, BP6, PS3 & BS3 disabled."
                                    }
                                  />
                                </React.Fragment>
                              }
                              onToggleClick={(e) => {
                                setClinicalEvidence(e.target.checked);
                                onDisableClinicalEvidence(e.target.checked);
                              }}
                              isChecked={showClinicalEvidence}
                            />
                          </div>
                        ) : (
                          ""
                        )}
                      </div>

                      <ManualComponentOverride
                        acmgRules={acmgRules}
                        classifications={classifications}
                        showSummaryView={showSummaryView}
                        allRulesToggleState={allRulesToggleState}
                        onToggleHandle={onToggleHandle}
                        onAcmgSelectChange={onAcmgSelectChange}
                        shouldShowACMGPoints={shouldShowACMGPoints}
                        rulesThatMetCriteria={rulesThatMetCriteria}
                        activeOverrideStrengths={activeOverrideStrengths}
                      />

                      {classifications && classifications.length > 0 ? (
                        <AutomatedCriteriaTable
                          acmgRules={acmgRules}
                          classifications={classifications}
                          activeOverrideStrengths={activeOverrideStrengths}
                          showFailedCriteria={showFailedCriteria}
                          activeRules={activeRulesList}
                          allRulesToggleState={allRulesToggleState}
                          onToggleHandle={onToggleHandle}
                          onAcmgSelectChange={onAcmgSelectChange}
                          shouldShowACMGPoints={shouldShowACMGPoints}
                          setFailedCriteria={setFailedCriteria}
                          rulesThatMetCriteria={rulesThatMetCriteria}
                        />
                      ) : (
                        <p>No rules have met the criteria.</p>
                      )}
                    </div>
                  )}
                </div>
              )}
              {/* this is needed for clinical. if we want it to work we need to pass store as a param in SomaticModeForm  */}
              {!__IS_COMPONENTS_PORTAL__ && (
                <SearchModal
                  show={isSearchModalOpen}
                  handleClose={() => {
                    setSearchModalOpen(false);
                  }}
                />
              )}
              <Modal
                isOpen={isTermsModalOpen}
                onRequestClose={() => {
                  setTermsModalOpen(false);
                }}
                ContentRender={() => <TermsOfUseACMG />}
              />
            </div>
          }
        />
      </div>
    </div>
  ) : null;
};

ACMGAnnotation.propTypes = AcmgAnnotationPropTypes;

ACMGAnnotation.defaultProps = AcmgAnnotationDefaultProps;

const mapStateToProps = (state) => {
  return {
    schema: state.schema,
    acmgRules: state.acmgRules,
    variantResult: state.variantResult,
    varsomeHost: state.varsomeHost,
    userEmail: state?.userEmail,
    acmgGene: getAcmgGene(state),
    classifications: getClassifications(state),
    rulesThatMetCriteria: getRulesThatMetCriteria(state),
    activeRulesList: getActiveRulesList(state),
    isSomatic: getIfSomatic(state),
    query: state.query,
    queryType: state.queryType,
    variantClassesList: state.variantClassesList,
    cancerExplain: getAcmgCancerExplain(state),
    verdict: getAcmgVerdict(state),
    variantId: getVariantId(state),
    pillsToggleState: getPillsToggleState(state),
    activeOverrideStrengths: getActiveOverrideStrengths(state),
    allRulesToggleState: getAllRulesToggleState(state),
    acmgSampleFindings: getAcmgSampleFindings(state),
    variantQueryMode: state.variantQueryMode,
    defaultVerdictRules: getAcmgDefaultVerdictRules(state),
    refseqTranscriptsOptions: getRefSeqTranscripts(state),
    ensemblTranscriptsOptions: getEnsemblTranscripts(state),
    shouldShowACMGPoints: !isThaliaVersionSmallerThanElevenPointFour(state),
    acmgVersionName: getACMGVersionName(state),
    isACMGThrottled: getACMGThrottlingStatus(state),
    apiUrl: state.apiUrl,
    transcriptName: getAcmgTranscriptName(state),
    transcriptReason: getAcmgTranscriptReason(state),
    refGenome: state?.genome?.name,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    setAcmgToggleToDefault: (params) =>
      dispatch(setAcmgToggleToDefaultAction(params)),
    setAcmgActiveOverridesToDefault: (params) =>
      dispatch(setAcmgActiveOverridesToDefaultAction(params)),
    setAcmgToggleState: (params) => dispatch(setAcmgToggleStateAction(params)),
    setAcmgActiveOverridesStrength: (params) =>
      dispatch(setAcmgActiveOverridesStrengthAction(params)),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(
  withErrorGuard(
    ACMGAnnotation,
    "ACMGAnnotation",
    "Germline Variant Classification"
  )
);
